import { Col, Row } from "react-bootstrap";
import classes from "@/Modals/BaseModal.module.css";
import Input from "@/components/Input/Input";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { DEFAULT_LANGUAGE } from "@/constant/Languages/language";
import { Button } from "react-bootstrap";

export default function LocalizedInput({
  formik,
  error,
  isAnnouncementsPage = false,
  isEdit = false,
}) {
  const locales = useSelector(
    (state) => state?.siteConfigurationReducer?.locales
  );

  const localeCodes = useMemo(() => {
    return locales ? locales.map((locale) => locale.code) : [];
  }, [locales]);

  const clearInputs = () => {
    localeCodes.forEach((localeCode) => {
      formik.setFieldValue(`localizations[${localeCode}]`, "");
    });
  };

  return (
    <>
      {isEdit && (
        <Row>
          <Col md={4}></Col>
          <Col md={4} className=" ml-5 mt-1 mb-2">
            <Button
              variant="secondary"
              className={classes.clearButton}
              onClick={clearInputs}
            >
              Clear All Translations
            </Button>
          </Col>
        </Row>
      )}
      {localeCodes.map((localeCode, index) => (
        <Row key={index}>
          <Col md={12}>
            <Input
              labelClass={classes.label}
              required={localeCode === DEFAULT_LANGUAGE ? true : false}
              label={`${
                isAnnouncementsPage ? "Text" : "Name"
              } (${localeCode.toUpperCase()})`}
              className={classes.inputDiv}
              placeholder={`Enter ${
                isAnnouncementsPage ? "Text" : "Name"
              } (${localeCode.toUpperCase()})`}
              inputContainerClass={classes.input}
              value={formik.values.localizations[localeCode]}
              setValue={(val) =>
                formik.setFieldValue(`localizations[${localeCode}]`, val)
              }
              errorTextClass={classes.errorText}
              errorText={
                (formik.touched.localizations?.[localeCode] &&
                  formik.errors.localizations?.[localeCode]) ||
                (error?.status === 422 &&
                  error?.response?.data?.errors?.[
                    `localizations.${localeCode}`
                  ]?.join(" "))
              }
            />
          </Col>
        </Row>
      ))}
    </>
  );
}
